export default __webpack_public_path__ + "static/media/dancers_banner.422c74a1.jpg";